import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-zinc-900 border-t border-amber-900/40" data-id="element-58">
      <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-59">
        <div className="mb-10" data-id="element-60">
          <p className="text-red-400 font-bold uppercase tracking-wider mb-4" data-id="element-61">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown theme="danger" className="scale-110" data-id="element-62" />
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-63">
          <div className="min-w-[600px] max-w-3xl mx-auto" data-id="element-64">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4 items-end" data-id="element-65">
              <div data-id="element-66"></div>
              <div className="font-bold text-zinc-400 uppercase text-sm tracking-wider text-center" data-id="element-67">
                🔨 MEGAPACK HERRERO ARGENTINO
              </div>
              <div className="font-bold text-amber-400 uppercase text-sm tracking-wider text-center flex items-center justify-center gap-1" data-id="element-68">
                ⭐ ⚡ MEGAPACK + NIVEL MAESTRO
              </div>
            </div>

            <div className="space-y-2" data-id="element-69">
              <div className="grid grid-cols-3 gap-4 bg-black/60 rounded-xl p-4 items-center border border-amber-900/20" data-id="element-70">
                <div className="text-zinc-400 font-medium text-sm" data-id="element-71">Módulos</div>
                <div className="text-white font-medium text-center" data-id="element-72">
                  6 Módulos
                </div>
                <div className="text-amber-300 font-bold text-center" data-id="element-73">
                  11 Módulos
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-black/60 rounded-xl p-4 items-center border border-amber-900/20" data-id="element-74">
                <div className="text-zinc-400 font-medium text-sm" data-id="element-75">Precio</div>
                <div className="text-white font-bold text-center" data-id="element-76">
                  $19.990 ARS
                </div>
                <div className="text-amber-300 font-bold text-center text-lg" data-id="element-77">
                  $27.990 ARS
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 bg-transparent p-4 items-center" data-id="element-78">
                <div data-id="element-79"></div>
                <div className="text-center" data-id="element-80">
                  <a href="https://www.centralpack.shop/cart/53707481940286:1" target="_blank" rel="noopener noreferrer" data-id="element-81">
                    <Button size="sm" variant="outline" className="w-full text-xs" data-id="element-82">
                      🔥 QUIERO MI MEGAPACK
                    </Button>
                  </a>
                </div>
                <div className="text-center" data-id="element-83">
                  <a href="https://www.centralpack.shop/cart/53707618484542:1" target="_blank" rel="noopener noreferrer" data-id="element-84">
                    <Button size="sm" variant="primary" className="w-full text-xs" data-id="element-85">
                      ⚡ QUIERO EL NIVEL MAESTRO
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-200 font-medium" data-id="element-86">
          <div className="flex items-center gap-1.5" data-id="element-87">
            <Lock className="w-4 h-4 text-amber-300" data-id="element-88" />
            <span data-id="element-89">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-90">
            <Zap className="w-4 h-4 text-amber-400" data-id="element-91" />
            <span data-id="element-92">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-93">
            <Shield className="w-4 h-4 text-amber-400" data-id="element-94" />
            <span data-id="element-95">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-96">
            <CreditCard className="w-4 h-4 text-amber-300" data-id="element-97" />
            <span data-id="element-98">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}